module.exports = require("core-js-pure/stable/date/now");